import { render, staticRenderFns } from "./SectionProjectsVideoBackground.vue?vue&type=template&id=4a2f2abc&"
import script from "./SectionProjectsVideoBackground.vue?vue&type=script&lang=js&"
export * from "./SectionProjectsVideoBackground.vue?vue&type=script&lang=js&"
import style0 from "./SectionProjectsVideoBackground.vue?vue&type=style&index=0&id=4a2f2abc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsPortfolioAtomProjectSliderBackground: require('/app/components/atoms/portfolio/AtomProjectSliderBackground.vue').default,MoleculesPortfolioMoleculeProjectsAndCities: require('/app/components/molecules/portfolio/MoleculeProjectsAndCities.vue').default})
